var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDoc = function SvgIconDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,31H3a3.054,3.054,0,0,1-3-3.1V3.1A3.054,3.054,0,0,1,3,0H20.379A1.468,1.468,0,0,1,21.44.455l8.121,8.392A1.564,1.564,0,0,1,30,9.941V27.9A3.054,3.054,0,0,1,27,31ZM4.5,3.1A1.528,1.528,0,0,0,3,4.65v21.7A1.527,1.527,0,0,0,4.5,27.9h21A1.527,1.527,0,0,0,27,26.35V12.4H21a3.055,3.055,0,0,1-3-3.1V3.1Zm18,21.7H7.5a1.551,1.551,0,0,1,0-3.1h15a1.551,1.551,0,0,1,0,3.1Zm0-6.2H7.5a1.551,1.551,0,0,1,0-3.1h15a1.551,1.551,0,0,1,0,3.1Zm-9-6.2h-6A1.527,1.527,0,0,1,6,10.85V7.75A1.527,1.527,0,0,1,7.5,6.2h6A1.527,1.527,0,0,1,15,7.75v3.1A1.527,1.527,0,0,1,13.5,12.4Z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-doc.42121cb5.svg";
export { ForwardRef as ReactComponent };